const EyeOpenIcon = ({ size = 24, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M20.831 11.7866C20.6777 11.573 17.3047 6.66016 12 6.66016C6.69529 6.66016 3.32223 11.5728 3.16897 11.7866C3.07698 11.929 3.07698 12.1069 3.16897 12.2138C3.32228 12.4274 6.69529 17.3402 12 17.3402C17.3047 17.3402 20.6777 12.4275 20.831 12.2138C20.923 12.107 20.923 11.8934 20.831 11.7866Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
        <path
            d="M12 9.75C13.2358 9.75 14.25 10.7642 14.25 12C14.25 13.2358 13.2358 14.25 12 14.25C10.7642 14.25 9.75 13.2358 9.75 12C9.75 10.7642 10.7642 9.75 12 9.75Z"
            stroke="currentColor"
            strokeWidth="1.5"
        />
    </svg>
)

export default EyeOpenIcon
